export default {
    "data": {
        "pc": {
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20220315/1647315921050.png",
                "https://s20.lgstatic.com/growth/activity/20210823/1629700265360.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629700197726.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629790949901.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629790959870.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629700240868.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629700252990.png"
            ],
            "imgList1": [
                "https://s20.lgstatic.com/growth/activity/20210823/1629710127497.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629711501472.png",
            ],
            "imgList2": [
                "https://s20.lgstatic.com/growth/activity/20210823/1629712200732.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629712214414.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629712224228.png",
                // "https://s20.lgstatic.com/growth/activity/20210823/1629712234619.png",
                "https://s21.lgstatic.com/growth/activity/20220315/1647315954979.png"
            ],
            "pcSwiperList": [
                "https://s20.lgstatic.com/growth/activity/20210823/1629711545647.png",
                "https://s20.lgstatic.com/growth/activity/20210823/1629711522579.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629711537968.png",
                "https://s21.lgstatic.com/growth/activity/20210823/1629711530925.png"
            ]
        },
        "h5": {
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20220315/1647315826341.png",
                "https://s21.lgstatic.com/growth/activity/20210824/1629772611876.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629772620752.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629772627990.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629772639682.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629772646939.png",
                "https://s21.lgstatic.com/growth/activity/20210824/1629772655300.png"
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210824/1629773773252.png",
                "https://s21.lgstatic.com/growth/activity/20210824/1629773785291.png"
            ],
            "imgList2": [
                "https://s20.lgstatic.com/growth/activity/20210824/1629775438281.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629775448219.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629775457250.png",
                "https://s21.lgstatic.com/growth/activity/20211126/1637918667849.jpg?x-oss-process=style/80",
                "https://s20.lgstatic.com/growth/activity/20220315/1647315857410.png"
            ],
            "swiperList": [
                "https://s20.lgstatic.com/growth/activity/20210824/1629774675055.png",
                "https://s21.lgstatic.com/growth/activity/20210824/1629776245842.png",
                "https://s20.lgstatic.com/growth/activity/20210824/1629776254386.png",
                "https://s21.lgstatic.com/growth/activity/20210824/1629776262080.png"
            ]
        },
        "stageList": [
            {
                "stage": "第一阶段",
                "title": "软件测试基础",
                "phaseTargetList": [
                    "掌握软件测试的基础概念",
                    "掌握名企经典的项目开发流程与测试流程",
                    "掌握业务架构分析的方法",
                    "掌握测试方案设计方法",
                    "掌握测试计划与测试总结报告的编写方法",
                ],
                "skillsList": [
                    "SCRUM、XP、持续集成/持续交付/DevOps",
                    "网关、微服务、关系型/非关系型数据库、消息管道、缓存系统、大数据系统、AI 人工智能系统",
                    "流程管理平台JIRA、Redmine、Gitlab、禅道",
                    "测试流程体系、测试左移、测试右移",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握软件测试的基础概念",
                            "掌握名企经典的项目开发流程与测试流程",
                            "掌握业务架构分析的方法",
                            "掌握测试方案设计方法",
                            "掌握测试计划与测试总结报告的编写方法",
                            "掌握常见的测试用例设计方法",
                            "掌握使用 JIRA 工具管理测试用例与 Bug 的方法",
                            "掌握 Bug 相关基础知识与概念",
                            "掌握名企测试技术与测试管理平台体系建设",
                            "了解测试行业经典的测试方法与经典书籍",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "SCRUM、XP、持续集成/持续交付/DevOps",
                            "网关、微服务、关系型/非关系型数据库、消息管道、缓存系统、大数据系统、AI 人工智能系统",
                            "流程管理平台JIRA、Redmine、Gitlab、禅道",
                            "测试流程体系、测试左移、测试右移",
                            "分层测试体系、单元测试、UI 测试、接口测试、白盒测试",
                            "用例管理平台、Bug 管理平台、代码管理平台、持续集成平台",
                            "等价类测试方法论、边界值测试方法论、因果图测试方法论 、判定表测试方法论 、场景法测试方法论",
                            "基于模型的测试方法论",
                            "白盒测试方法论、代码覆盖、流程覆盖、精准化测试",
                            "测试用例设计面试题解析",
                            "测试计划模版，测试报告模版",
                            "业务架构分析工具 Plantuml 、时序图 、架构图、 活动图、 思维导图",
                            "Bug 生命周期",
                        ]
                    }
                ]
            }, {
                "stage": "第二阶段",
                "title": "软件测试技术基础 Linux Bash Git MySQL",
                "phaseTargetList": [
                    "掌握Linux上的测试环境部署能力",
                    "掌握Linux上的性能分析能力",
                    "掌握Linux上的数据分析能力",
                    "掌握代码版本管理工具Git和常见代码管理平台的使用能力",
                    "掌握 SQL 语法与多种数据库的使用",
                ],
                "skillsList": [
                    "Linux 系统、Linux 文件、进程、网络等核心概念",
                    "Linux 核心三剑客命令 grep、 awk、 sed 与数据处理分析",
                    "服务器基本的数据例如性能及网络的统计",
                    "Bash 编程语法与shell 脚本编写",
                    "Linux 环境中配置 Java、Python、NodeJs、Android-SDK 等",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握Linux上的测试环境部署能力",
                            "掌握Linux上的性能分析能力",
                            "掌握Linux上的数据分析能力",
                            "掌握代码版本管理工具Git和常见代码管理平台的使用能力",
                            "掌握 SQL 语法与多种数据库的使用",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "Linux 系统、Linux 文件、进程、网络等核心概念",
                            "Linux 核心三剑客命令 grep、 awk、 sed 与数据处理分析",
                            "服务器基本的数据例如性能及网络的统计",
                            "Bash 编程语法与shell 脚本编写",
                            "Linux 环境中配置 Java、Python、NodeJs、Android-SDK 等",
                            "代码版本管理工具 Git 常用命令",
                            "Github、Gitlab 等常见代码管理平台的使用",
                            "MySQL 、Redis、 MongoDB ",
                            "多表查询、内连接、外连接、子查询",
                        ]
                    }
                ]
            }, {
                "stage": "第三阶段",
                "title": "Python 编程语言",
                "phaseTargetList": [
                    "掌握Python编程语言语法",
                    "掌握面向对象编程技能",
                    "掌握Python常见包的使用",
                    "掌握Pytest测试框架",
                    "掌握Allure2测试报告框架",
                ],
                "skillsList": [
                    "Python 的循环、判断、方法 等基础语法",
                    "Python 最好用依赖管理工具 pip",
                    "Python 常用第三方模块，包括日志模块、excel 模块、数据库操作模块等",
                    "Python 进阶知识、装饰器、则表达式、多线程等",
                    "Pytest 测试用例结构，编写完整用例",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握Python编程语言语法",
                            "掌握面向对象编程技能",
                            "掌握Python常见包的使用",
                            "掌握Pytest测试框架",
                            "掌握Allure2测试报告框架"
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "Python 的循环、判断、方法 等基础语法",
                            "Python 最好用依赖管理工具 pip",
                            "Python 常用第三方模块，包括日志模块、excel 模块、数据库操作模块等",
                            "Python 进阶知识、装饰器、则表达式、多线程等。",
                            "Pytest 测试用例结构，编写完整用例。",
                            "Pytest 参数化、标记、跳过等常用装饰器",
                            "Pytest 高级知识 fixture、conftest ",
                            "Pytest 自定义用例顺序 并行执行测试用例 等高级用法",
                            "Pytest 插件开发，实现 Pytest 测试框架的个人定制",
                            "Pytest 结合测试报告的安装与配置",
                            "Pytest 结合测试报告信息添加，包括用例描述、附件等"
                        ]
                    }
                ]
            }, {
                "stage": "第四阶段",
                "title": "Web 自动化测试",
                "phaseTargetList": [
                    "掌握 Web 自动化测试用例录制、编写、流程编排与实战能力",
                    "掌握绕过扫码、滑块、短信校验等认证方法的自动化测试方案",
                    "掌握 Page Object 设计模式，实现测试用例的良好分层",
                    "掌握多浏览器分布式执行的自动化测试方案",
                    "了解行业其他 Web 自动化测试框架 Cypress、 Playwright",
                ],
                "skillsList": [
                    "html、js、css 基础知识以及常见相关 bug",
                    "Selenium IDE、录制、回放、基本使用",
                    "常见控件定位方法 id 、name、 css 、xpath 、link 定位",
                    "Selenium 经典的三种等待方式 强制等待 隐式等待 显式等待 ",
                    "网页 frame 与多窗口处理",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握 Web 自动化测试用例录制、编写、流程编排与实战能力",
                            "掌握绕过扫码、滑块、短信校验等认证方法的自动化测试方案",
                            "掌握 Page Object 设计模式，实现测试用例的良好分层",
                            "掌握多浏览器分布式执行的自动化测试方案",
                            "了解行业其他 Web 自动化测试框架 Cypress、 Playwright",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "html、js、css 基础知识以及常见相关 bug",
                            "Selenium IDE、录制、回放、基本使用",
                            "常见控件定位方法 id 、name、 css 、xpath 、link 定位",
                            "Selenium 经典的三种等待方式 强制等待 隐式等待 显式等待 ",
                            "网页 frame 与多窗口处理",
                            "文件上传弹框处理",
                            "利用远程调试技术实现浏览器复用",
                            "利用 cookie 复用实现自动化登录",
                            "Selenium 多浏览器处理chrome、firefox 等浏览器的自动化支持",
                            "执行 javascript 脚本、使用 Selenium 直接在当前页面中进行 js 交互",
                            "headless 无头浏览器使用 、 Selenium options 无头浏览器等常用配置",
                            "Page Object 模式的发展历史介绍、六大设计原则",
                            "Page Object 设计模式应用、BasePage 封装、基于 Page Object 模式的测试用例编写",
                            "测试人论坛自动化测试实战",
                            "电子商城平台自动化测试实战 ",
                        ]
                    }
                ]
            }, {
                "stage": "第五阶段",
                "title": "App 自动化测试",
                "phaseTargetList": [
                    "掌握 App 自动化测试用例录制、编写、流程编排与实战能力",
                    "掌握 Page Object 设计模式，实现测试用例的良好分层",
                    "掌握多设备分布式执行的自动化测试方案",
                    "掌握Android、iOS、手机浏览器、微信小程序的自动化测试能力",
                    "掌握App专项测试能力",
                ],
                "skillsList": [
                    "App 项目测试流程介绍",
                    "App 包结构解读",
                    "常用模拟器使用，genymotion、网易 mumu、Android/iOS 官方模拟器",
                    "adb 命令介绍，通过 adb 命令获取性能数据信息，monkey",
                    "Appium自动化测试用例录制、编写与实战",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握 App 自动化测试用例录制、编写、流程编排与实战能力",
                            "掌握 Page Object 设计模式，实现测试用例的良好分层",
                            "掌握多设备分布式执行的自动化测试方案",
                            "掌握Android、iOS、手机浏览器、微信小程序的自动化测试能力",
                            "掌握App专项测试能力",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "App 项目测试流程介绍",
                            "App 包结构解读",
                            "常用模拟器使用，genymotion、网易 mumu、Android/iOS 官方模拟器",
                            "adb 命令介绍，通过 adb 命令获取性能数据信息，monkey",
                            "Appium自动化测试用例录制、编写与实战",
                            "常见控件定位方法，id，aid，xpath css 原生定位",
                            "特殊控件 toast 识别",
                            "强制等待 隐式等待 显式等待 ",
                            "App 弹窗异常处理",
                            "Appium 原理解析",
                            "测试框架解耦与二次封装",
                            "Android Webview 技术原理与架构分析",
                            "Webview 自动化测试",
                            "微信小程序自动化测试",
                            "手机浏览器自动化测试",
                            "iOS自动化测试",
                            "多设备自动化测试",
                            "自动遍历测试技术",
                            "多设备管理平台 stf",
                            "App专项测试 性能分析 卡顿分析 耗电量测试 弱网测试 健壮性测试 兼容性测试",
                            "用户端自动化测试经典面试题",
                            "企业微信App自动化测试实战",
                        ]
                    }
                ]
            }, {
                "stage": "第六阶段",
                "title": "接口自动化测试",
                "phaseTargetList": [
                    "了解接口测试的价值、知识体系与学习路线",
                    "掌握常见协议tcp、 http协议结构与通讯方式",
                    "掌握常用接口测试工具 postman、 curl",
                    "掌握常用抓包工具 Charles 与 Fiddler",
                    "掌握接口Mock、Mock server技术",
                ],
                "skillsList": [
                    "常见的接口协议，tcpdump 与 wireshark 的使用",
                    "postman、 curl基础使用",
                    "App 抓包工具 charles 、 fiddler",
                    "使用最流行的 requests 进行接口自动化测试",
                    "以 json、xml 结构化的格式发送请求",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "了解接口测试的价值、知识体系与学习路线",
                            "掌握常见协议tcp、 http协议结构与通讯方式",
                            "掌握常用接口测试工具 postman、 curl",
                            "掌握常用抓包工具 Charles 与 Fiddler",
                            "掌握接口Mock、Mock server技术",
                            "掌握HTTP 、RPC、 websocket、 socket接口自动化测试体系",
                            "掌握微服务测试接口自动化测试体系",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "常见的接口协议，tcpdump 与 wireshark 的使用",
                            "postman、 curl基础使用",
                            "App 抓包工具 charles 、 fiddler",
                            "使用最流行的 requests 进行接口自动化测试",
                            "以 json、xml 结构化的格式发送请求",
                            "利用 xpath、jsonpath、schema 进行断言，数据库操作与断言",
                            "form 表单的测试与请求模拟、文件上传测试",
                            "接口加密与解密",
                            "多套被测环境",
                            "多协议封装设计，dubbo、thrift、pb、socket、websocket协议的接口测试",
                            "接口鉴权的多种情况与解决方案",
                            "接口管理框架 Swagger 代码生成框架 Swagger CodeGen",
                            "gor 流量回放、diffy 接口 diff 测试工具",
                            "har 文件格式讲解与用例自动生成",
                            "stub 、mock、 fake 讲解与应用、mitmproxy 的使用场景与使用方法",
                            "电子商城接口自动化测试框架实战",
                            "接口测试经典面试题 ",
                        ]
                    }
                ]
            }, {
                "stage": "第七阶段",
                "title": "安全测试",
                "phaseTargetList": [
                    "掌握常见安全漏洞的原理与解决方法",
                    "掌握常用安全测试工具 owasp-zap 的使用",
                    "掌握安全测试实施能力",
                ],
                "skillsList": [
                    "OWASP 的 top10 安全漏洞与安全防护体系",
                    "搭建安全测试演练环境实操常见安全漏洞",
                    "zap、burpsuite、sqlmap 等知名安全测试工具介绍",
                    "命令注入漏洞、sql 注入漏洞、xss 漏洞、csrf 漏洞、越权访问漏洞",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握常见安全漏洞的原理与解决方法",
                            "掌握常用安全测试工具 owasp-zap 的使用",
                            "掌握安全测试实施能力",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "OWASP 的 top10 安全漏洞与安全防护体系",
                            "搭建安全测试演练环境实操常见安全漏洞",
                            "zap、burpsuite、sqlmap 等知名安全测试工具介绍",
                            "命令注入漏洞、sql 注入漏洞、xss 漏洞、csrf 漏洞、越权访问漏洞",
                        ]
                    }
                ]
            }, {
                "stage": "第八阶段",
                "title": "性能测试",
                "phaseTargetList": [
                    "掌握性能测试工具JMeter",
                    "掌握性能分析命令 top 、ps、 netstat、 iostat、 nmon",
                    "掌握性能监控平台Prometheus",
                    "熟悉应用性能监控 SkyWalking",
                    "掌握性能剖析工具 JVM ebpf",
                ],
                "skillsList": [
                    "行业流行性能压测工具介绍",
                    "行业流行性能监控工具介绍",
                    "行业流行性能剖析工具介绍",
                    "性能测试流程与方法 性能测试计划 性能测试用例设计 性能测试报告",
                    "JMeter性能测试工具",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握性能测试工具JMeter",
                            "掌握性能分析命令 top 、ps、 netstat、 iostat、 nmon",
                            "掌握性能监控平台Prometheus",
                            "熟悉应用性能监控 SkyWalking",
                            "掌握性能剖析工具 JVM ebpf",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "行业流行性能压测工具介绍",
                            "行业流行性能监控工具介绍",
                            "行业流行性能剖析工具介绍",
                            "性能测试流程与方法 性能测试计划 性能测试用例设计 性能测试报告",
                            "JMeter性能测试工具",
                            "JMeter参数化、分布式调度、BeanShell",
                            "服务端性能监控系统 Prometheus",
                            "数据分析系统 Grafana",
                            "JVM性能剖析工具jvisualvm、堆内存分析工具MAT",
                            "内核性能分析工具ebpftrace",
                            "应用性能监控系统 SkyWalking",
                        ]
                    }
                ]
            }, {
                "stage": "第九阶段",
                "title": "Docker容器技术与K8S容器管理",
                "phaseTargetList": [
                    "掌握 Docker 容器化技术",
                    "掌握 Docker-compose 技术",
                    "掌握 Docker 镜像构建技术",
                    "掌握K8S容器编排技术",
                    "掌握持续交付体系",
                ],
                "skillsList": [
                    "容器技术介绍 ",
                    "Docker 容器管理、镜像管理",
                    "使用Docker搭建 Nginx、MySQL 、Jenkins、JIRA",
                    "搭建测试用例管理平台 testlink",
                    "Docker 与容器网络",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握 Docker 容器化技术",
                            "掌握 Docker-compose 技术",
                            "掌握 Docker 镜像构建技术",
                            "掌握K8S容器编排技术",
                            "掌握持续交付体系",
                            "掌握DevOps体系",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "容器技术介绍 ",
                            "Docker 容器管理、镜像管理",
                            "使用Docker搭建 Nginx、MySQL 、Jenkins、JIRA",
                            "搭建测试用例管理平台 testlink",
                            "Docker 与容器网络",
                            "Docker compose 多容器实战",
                            "Docker 容器镜像制作命令",
                            "Docker 制作容器镜像实战",
                            "Dockerfile 的详细教程",
                            "Docker 私有镜像仓库实战",
                            "k8s 容器编排体系介绍",
                            "k8s dashboard 使用",
                            "使用 k8s 批量运行测试用例",
                            "k8s 在测试中的应用",
                        ]
                    }
                ]
            }, {
                "stage": "第十阶段",
                "title": "持续交付DevOps体系",
                "phaseTargetList": [
                    "掌握持续集成体系的应用",
                    "掌握持续交付体系的应用",
                    "掌握DevOps体系的应用",
                ],
                "skillsList": [
                    "持续集成体系介绍",
                    "持续交付体系介绍",
                    "DevOps体系介绍",
                    "持续集成平台Jenkins",
                    "静态扫描体系集成",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握持续集成体系的应用",
                            "掌握持续交付体系的应用",
                            "掌握DevOps体系的应用",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "持续集成体系介绍",
                            "持续交付体系介绍",
                            "DevOps体系介绍",
                            "持续集成平台Jenkins",
                            "静态扫描体系集成",
                            "单元测试体系集成",
                            "代码覆盖率集成",
                            "容器构建持续集成",
                            "持续集成实战-接口测试集成实战",
                            "持续集成实战-web 自动化测试集成实战",
                            "持续集成实战-App 自动化测试集成实战",
                        ]
                    }
                ]
            }, {
                "stage": "第十一阶段",
                "title": "测试左移与测试右移",
                "phaseTargetList": [
                    "掌握代码分析、代码审计能力",
                    "掌握单元测试能力",
                    "掌握覆盖率统计与分析能力",
                    "掌握质量门禁体系",
                    "掌握精准测试能力",
                ],
                "skillsList": [
                    "sonarqube代码分析技术体系",
                    "sonarqube maven 项目分析",
                    "sonarqube gradle 项目分析",
                    "代码复杂度分析",
                    "代码扫描规则定制",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握代码分析、代码审计能力",
                            "掌握单元测试能力",
                            "掌握覆盖率统计与分析能力",
                            "掌握质量门禁体系",
                            "掌握精准测试能力",
                            "了解测试右移常见实践方法",
                            "掌握质量监控体系",
                            "掌握应用性能监控体系",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "sonarqube代码分析技术体系",
                            "sonarqube maven 项目分析",
                            "sonarqube gradle 项目分析",
                            "代码复杂度分析",
                            "代码扫描规则定制",
                            "代码变更检测与新增代码分析",
                            "代码覆盖率统计工具JaCoCo",
                            "集成测试覆盖率统计",
                            "精准测试体系",
                            "logstash 讲解",
                            "elastic search 搜索引擎讲解",
                            "kibana 可视化分析平台",
                            "应用性能监控平台SkyWalking",
                        ]
                    }
                ]
            }, {
                "stage": "第十二阶段",
                "title": "数据结构与算法、设计模式",
                "phaseTargetList": [
                    "掌握常见数据结构与代码实现方案",
                    "掌握常见算法与代码实现方案",
                    "掌握常见设计模式与代码实现方案",
                ],
                "skillsList": [
                    "算法性能评估 ，时间复杂度、空间复杂度",
                    "经典排序算法 、冒泡排序 、选择排序",
                    "队列，管道应用、消息收发、FIFO 先进先出",
                    "堆栈 ,  LIFO 后进先出、函数调用的堆与栈的区别",
                    "单链表、双链表的应用与常见算法",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握常见数据结构与代码实现方案",
                            "掌握常见算法与代码实现方案",
                            "掌握常见设计模式与代码实现方案",
                        ]
                    }, {
                        "t": "关键技术点",
                        "desc": [
                            "算法性能评估 ，时间复杂度、空间复杂度",
                            "经典排序算法 、冒泡排序 、选择排序",
                            "队列，管道应用、消息收发、FIFO 先进先出",
                            "堆栈 ,  LIFO 后进先出、函数调用的堆与栈的区别",
                            "单链表、双链表的应用与常见算法",
                            "二叉树的创建，前序、中序、后序遍历算法",
                            "多叉树基本结构、算法与应用场景",
                            "使用递归算法替代传统循环",
                            "单例设计模式 ",
                            "工厂方法， 简单工厂方法、工厂模式、抽象工厂模式",
                            "常用设计模式讲解",
                            "设计模式基本原则：开放-关闭原则、 里氏替换原则、 依赖倒转原则 、接口隔离原则、 迪米特法则、 组合/聚合复用原则",
                        ]
                    }
                ]
            }, {
                "stage": "第十三阶段",
                "title": "测试平台开发",
                "phaseTargetList": [
                    "握数据驱动测试框架设计能力",
                    "掌握测试平台设计能力",
                    "掌握测试平台后端开发能力",
                    "掌握测试平台前端开发能力",
                ],
                "skillsList": [
                    "测试框架设计思想",
                    "数据驱动测试框架介绍",
                    "打造自己的测试框架",
                    "接口路由技术",
                    "ORM",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握数据驱动测试框架设计能力",
                            "掌握测试平台设计能力",
                            "掌握测试平台后端开发能力",
                            "掌握测试平台前端开发能力",
                        ]
                    },
                    {
                        "t": "关键技术点",
                        "desc": [
                            "测试框架设计思想",
                            "数据驱动测试框架介绍",
                            "打造自己的测试框架",
                            "接口路由技术",
                            "ORM",
                            "从零到一掌握最火前端框架 Vue.js",
                            "响应式 Vue 页面布局组件-Vuetify",
                            "Vue 路由管理组件-Router",
                            "Vue 访问 api 组件-axios",
                            "测试平台架构设计",
                            "测试用例导入与管理体系",
                        ]
                    }
                ]
            }, {
                "stage": "第十四阶段",
                "title": "典型业务领域测试体系",
                "phaseTargetList": [
                    "掌握中间件测试方法",
                    "掌握SDK测试方法",
                ],
                "skillsList": [
                    "常用的中间件介绍：redis，kafka，ElasticSearch 等",
                    "redis 的数据同步策略以及数据一致性保证",
                    "哨兵模式的设计架构，如何理解读写分离，选举和脑裂",
                    "缓存失效下的熔断和降级以及测试方法",
                    "缓存击穿下的处理方法和测试方法",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握中间件测试方法",
                            "掌握SDK测试方法",
                        ]
                    },
                    {
                        "t": "关键技术点",
                        "desc": [
                            "常用的中间件介绍：redis，kafka，ElasticSearch 等",
                            "redis 的数据同步策略以及数据一致性保证",
                            "哨兵模式的设计架构，如何理解读写分离，选举和脑裂",
                            "缓存失效下的熔断和降级以及测试方法",
                            "缓存击穿下的处理方法和测试方法",
                            "缓存穿透下的测试方法",
                            "kafka  producer 与 consumer",
                            "kafka 场景下的常用测试方法",
                            "Android SDK测试方法",
                        ]
                    }
                ]
            }, {
                "stage": "第十五阶段",
                "title": "软件测试开发岗面试指导",
                "phaseTargetList": [
                    "掌握简历书写技巧",
                    "了解互联网公司面试流程",
                    "掌握面试中的常用沟通技巧",
                    "掌握薪资谈判技巧",
                    "辨别 offer 优劣，完成职场晋升",
                ],
                "skillsList": [
                    "构建条理清晰的简历内容架构",
                    "巧用数据量化自己的工作成果",
                    "互联网大厂面试流程介绍",
                    "高效备战面试",
                    "设计一个让面试官记住你的自我介绍",
                ],
                "details": [
                    {
                        "t": "学习目标",
                        "desc": [
                            "掌握简历书写技巧",
                            "了解互联网公司面试流程",
                            "掌握面试中的常用沟通技巧",
                            "掌握薪资谈判技巧",
                            "辨别 offer 优劣，完成职场晋升",
                        ]
                    },
                    {
                        "t": "关键技术点",
                        "desc": [
                            "构建条理清晰的简历内容架构",
                            "巧用数据量化自己的工作成果",
                            "互联网大厂面试流程介绍",
                            "高效备战面试",
                            "设计一个让面试官记住你的自我介绍",
                            "机智应对 HR 软技能考核",
                            "薪资谈判常用技巧",
                            "offer评估实用技巧",
                        ]
                    }
                ]
            }
        ],
        projectsDetail: [
            {
                title: '项目一',
                projectTitle: '企业微信自动化测试全流程实战',
                details: [
                    {
                        title: '项目介绍',
                        txt: '企业微信是腾讯微信团队打造的企业通讯与办公工具，具有与微信一致的沟通体验，丰富的OA应用，和连接微信生态的能力，可帮助企业连接内部、连接生态伙伴、连接消费者。专业协作、安全管理、人际服务。'
                    },
                    {
                        title: '应用技术',
                        txt: 'web自动化测试、接口自动化测试、功能测试、持续集成'
                    }
                ],
                projectImgs: [
                    "https://s21.lgstatic.com/growth/activity/20220902/1662108498165.png"
                ]
            },
            {
                title: '项目二',
                projectTitle: 'litemall电子商城系统',
                details: [
                    {
                        title: '项目介绍',
                        txt: 'litemall电子商城系统，包含用户和管理员两个角色。用户主要使用小程序与商城前端，管理员有专门系统的后端平台。主要功能包含会员管理，商城管理，商品管理，推广管理，系统管理，配置管理，统计报表等功能。'
                    },
                    {
                        title: '应用技术',
                        txt: 'web自动化测试、接口自动化测试、功能测试、持续集成'
                    }
                ],
                projectImgs: [
                    "https://s20.lgstatic.com/growth/activity/20220902/1662108555529.png"
                ]
            },
            {
                title: '项目三',
                projectTitle: '测试人论坛',
                details: [
                    {
                        title: '项目介绍',
                        txt: '基于Discourse 搭建的测试工程师技术社区。主要功能包括发帖、回复、点赞、收藏等社交性功能，还有搜索、分类等数据管理功能。'
                    },
                    {
                        title: '应用技术',
                        txt: 'web自动化测试、功能测试'
                    }
                ],
                projectImgs: [
                    "https://s20.lgstatic.com/growth/activity/20220902/1662108605722.png"
                ]
            },
            {
                title: '项目四',
                projectTitle: '宠物商店接口自动化测试实战',
                details: [
                    {
                        title: '项目介绍',
                        txt: '是一个在线的小型的商城。主要提供了增删查改等操作接口。结合swagger实现了接口的管理'
                    },
                    {
                        title: '应用技术',
                        txt: '接口测试、接口自动化测试'
                    }
                ],
                projectImgs: [
                    "https://s21.lgstatic.com/growth/activity/20220902/1662108650690.png"
                ]
            },
            {
                title: '项目五',
                projectTitle: '动手打造测试平台',
                details: [
                    {
                        title: '项目介绍',
                        txt: '测试平台是一个可以实现测试用例调度，测试结果分析的平台。是由霍格沃兹测试学社开发的测试平台产品，练习过程中，学员需要掌握测试平台相关的设计方案与开发技术'
                    },
                    {
                        title: '应用技术',
                        txt: 'Vue.js前端开发、Flask后端开发、测试用例设计、测试调度设计'
                    }
                ],
                projectImgs: [
                    "https://s20.lgstatic.com/growth/activity/20220902/1662108697157.png"
                ]
            }
        ]
    }
}